import React, { lazy } from "react";
import { Icon } from "@chakra-ui/react";
import * as MdIcons from "react-icons/md";
import * as FaIcons from "react-icons/fa";
import * as RiIcons from "react-icons/ri";
import * as GiIcons from "react-icons/gi";
import SignIn from "views/auth/signIn";
import { MdLogin } from "react-icons/md"; 

const ICONS = { ...MdIcons, ...FaIcons, ...RiIcons, ...GiIcons };

export const loadIcon = (iconName) => {
  if (!iconName) return null;
  const IconComp = ICONS[iconName];
  return IconComp ? <Icon as={IconComp} w={6} h={6} color="inherit" /> : null;
};

export const loadComponent = (componentPath) => {
  if (!componentPath) return () => <div>Missing Component Path</div>;
  try {
    return lazy(() => import(`./views/admin/${componentPath}.jsx`));
  } catch (err) {
    console.error("❌ Failed to load:", componentPath, err);
    return () => <div>Failed to load {componentPath}</div>;
  }
};

export const buildRoutes = (menuData = []) => {
  if (!Array.isArray(menuData)) return [];

  const map = {};
  const roots = [];

  menuData.forEach((m) => {
    map[m.id] = {
      id: m.id,
      name: m.name,
      layout: "/admin",
      path: m.path,
      icon: loadIcon(m.icon),
      component: m.component ? loadComponent(m.component) : null,
      children: [],
      parentId: m.parentId,
      sortOrder: m.sortOrder || 0,
    };
  });

  menuData.forEach((m) => {
    if (m.parentId && map[m.parentId]) {
      map[m.parentId].children.push(map[m.id]);
    } else {
      roots.push(map[m.id]);
    }
  });

  const sortRecursive = (arr) => {
    arr.sort((a, b) => a.sortOrder - b.sortOrder);
    arr.forEach((r) => r.children?.length && sortRecursive(r.children));
    return arr;
  };

  return sortRecursive(roots);
};


const routes = [
  {
    name: "Signin",
    layout: "/auth",
    path: "/sign-in",
    icon: <Icon as={MdLogin} w={5} h={5} color="inherit" />,
    component: SignIn,
    hide: true,
  },
];

export default routes;

// add this line at the very end
export const Logout = [];


// ✅ utils/menuUtils.js or inside routes.js

export const buildMenuTree = (menuItems) => {
  const map = {};
  const roots = [];

  menuItems.forEach((item) => {
    map[item.id] = { ...item, children: [] };
  });

  menuItems.forEach((item) => {
    if (item.parentId && map[item.parentId]) {
      map[item.parentId].children.push(map[item.id]);
    } else {
      roots.push(map[item.id]);
    }
  });

  return roots;
};

